import { Component, Input } from '@angular/core'

import { ScopeElementsConfig } from '../models'

@Component({ selector: 'scope-roles-header', templateUrl: './roles-header.component.html' })
export class RolesHeaderComponent {
  @Input() config: ScopeElementsConfig
  @Input() level: number
}
